import React, { useEffect, useState } from "react";
import api from "~/services/api";
import { Label, Input, Select } from "~/componentes/CustomForm";
import Acoordion from '~/componentes/Acoordion';
import Logo from '~/assets/logos/Logo Locomotiva.svg';

import { Container } from "./styles";
import CustomScrollBar from "~/componentes/CustomScrollBar";
import { Materialize } from "~/styles/materializeGrid";
import { SLModalFooter } from "~/pages/Sistema/componentes/SistemaList";
import ShowConfirmacao from "~/utils/ShowConfirmacao";
import ResponsaveisList from "../ResponsaveisList";

function CreateEditContent({ mountedData }) {
  const [responsaveis, setResponsaveis] = useState([]);
  let analista = [{ id: 1, nome: 'Jorge Medeiros', aberto: true },{ id: 1, nome: 'Jorge Medeiros', aberto: true },{ id: 1, nome: 'Jorge Medeiros', aberto: true }];
  const [ativo, setAtivo] = useState(!mountedData ? "true" : mountedData?.ativo ? "true" : "false");

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = {
          ...data,
          ...(mountedData?.id ? { id: mountedData?.id } : {}),
          ativo: ativo === "true" ? true : false,
          responsaveis,
          tipo: "PRO",
        }
        let response;
        if (mountedData?.id)
          response = await api.put("/signed/empresa/gestorprojeto/etapa/etapa", thisData);
        else
          response = await api.post("/signed/empresa/gestorprojeto/etapa/etapa", thisData);

        if (response?.status === 200) {
          closeReload && closeReload();
        }
        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao ${mountedData?.id ? "atualizar" : "cadastrar"} essa Etapa, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja ${mountedData?.id ? "atualizar" : "cadastrar"} essa Etapa?`,
        successModal: `Etapa ${mountedData?.id ? "atualizada" : "cadastrada"} com sucesso!`,
      }
    );
  }

  return (
    <Container onSubmit={handleSubmit}>
      <CustomScrollBar fixScrollMargin autoHeightMax="75vh">
        <Materialize className="padding-form">
          <div className="row header">
            <p className="h-descricao">Preencha as informações corretamente, e se atente ao (*) pois são campos obrigatórios</p>
          </div>
          <div className="back">
            <div className="back-color">
              <div className="content">
                <div className="back-info">
                  <div className="card-top-info">
                    <div className="card-top">
                      <div className="card-top-left">
                        <p className="cod">#0001</p>
                        <p className="titulo"><span className="bold">Nome: </span>Locomotiva</p>
                        <p className="cnpj"><span className="bold">CNPJ: </span>00000000</p>
                      </div>
                      <div className="card-info">
                        <p className="sub-titulo"><span className="bold">E-mail: </span> responsavel@locomotiva.com.br</p>
                        <p className="rsp"><span className="bold">Responsável: </span> Rsp. do Cliente</p>
                      </div>
                    </div>
                    <div className="point">
                        <div className="logo">
                          <img className="logo_img" src={Logo} alt="Vazio" />
                        </div>
                    </div>
                  </div>
                  <div className="acord">
                    <div className="col s3 m3 l3">
                      <Acoordion title="Módulos Utilizados*" name="a" itens={analista} /> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Materialize>
      </CustomScrollBar>
    </Container>
  );
}

export default CreateEditContent;
